import store from './store';
import i18n from '@/i18n';
import DEFINES from '@/defines';

//to check user role in company
var isUserRole = (role, company_id) => {
  return role
    ? store.getters['company/userRoleInCompany'] (company_id) === role
    : null;
};

/**
 *to check wether a user has valid permissions or not *
 */
var isUserAllow = (role, company_id) => {
  return store.getters['company/userRoleInCompany'] (company_id) >= role;
};

var USER = company_id => {
  return [
    {
      /* Visible to only company owner, admin  */
      visible: isUserAllow (DEFINES.ROLE_ADMIN, company_id),
      title: 'Billing',
      icon: 'screener_sales',
      route: 'transaction.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.profile'),
      icon: 'rms_user_profile',
      route: 'UserProfile',
    },
  ];
};

const ADMIN = [
  {
    visible: true,
    title: i18n.t ('screener.admin.drawer.menu.dashboard'),
    icon: 'rms_company_dashboard',
    route: 'AdminDashboard',
  },
  {
    visible: true,
    title: i18n.t ('rms.drawer.admin.companies'),
    icon: 'rms_bank',
    route: 'AdminCompaniesList',
  },
  {
    visible: true,
    title: i18n.t ('screener.title'),
    icon: 'rms_film',
    route: 'AdminScreeningList',
  },
  {
    visible: true,
    title: i18n.t ('screener.admin.drawer.menu.audience'),
    icon: 'rms_company_members',
    route: 'AdminConsumerList',
  },
  {
    visible: true,
    title: i18n.t ('screener.admin.drawer.menu.films'),
    icon: 'rms_film',
    route: 'AdminFilmList',
  },
  // {
  //   visible: true,
  //   title: i18n.t ('screener.admin.drawer.menu.screener'),
  //   icon: 'rms_film',

  //   subMenu: [
  //     {
  //       title: i18n.t ('screener.admin.drawer.menu.all_screenings'),
  //       icon: 'rms_film',
  //       route: 'AdminScreeningList',
  //       params: {},
  //     },
  //   ],
  // },

  {
    visible: true,
    title: i18n.t ('rms.drawer.admin.users'),
    icon: 'rms_user_profile',
    route: 'AdminUserList',
  },
  {
    visible: true,
    title: i18n.t ('mew.drawer.admin.widgets'),
    icon: 'mew_widgets',
    route: 'AdminWidgetList',
  },
  {
    visible: true,
    title:i18n.t ('mew.drawer.admin.homepage'),
    icon:'mew_apps',
    route:'AdminPageList'
  }
  // {
  //   visible: true,
  //   title: i18n.t ('subscription.title'),
  //   icon: 'rms_user_profile',
  //   route: 'AdminSubscriptionList',
  // },
  // {
  //   visible: true,
  //   title: i18n.t ('rms.drawer.admin.config'),
  //   icon: 'rms_setting',

  //   subMenu: [
  //     {
  //       title: i18n.t ('rms.drawer.admin.tag.film_genere'),
  //       icon: 'rms_movie',
  //       route: 'AdminTags',
  //       params: {
  //         tag_type: DEFINES.TAG_TYPE.FOR_FILM_GENRE,
  //       },
  //     },
  //     {
  //       title: i18n.t ('rms.drawer.admin.tag.rights'),
  //       icon: 'rms_transactions',
  //       route: 'AdminTags',
  //       params: {
  //         tag_type: DEFINES.TAG_TYPE.FOR_RIGHTS,
  //       },
  //     },
  //     {
  //       title: i18n.t ('rms.drawer.admin.tag.territories'),
  //       icon: 'rms_transactions',
  //       route: 'AdminTags',
  //       params: {
  //         tag_type: DEFINES.TAG_TYPE.FOR_TERRITORIES,
  //       },
  //     },
  //     {
  //       title: i18n.t ('rms.drawer.admin.tag.film_type'),
  //       icon: 'rms_film',
  //       route: 'AdminTags',
  //       params: {
  //         tag_type: DEFINES.TAG_TYPE.FOR_FILM_TYPE,
  //       },
  //     },
  //     {
  //       title: i18n.t ('rms.drawer.admin.tag.film_format'),
  //       icon: 'rms_video',
  //       route: 'AdminTags',
  //       params: {
  //         tag_type: DEFINES.TAG_TYPE.FOR_FILM_FORMAT,
  //       },
  //     },
  //     {
  //       title: i18n.t ('rms.drawer.admin.tag.language'),
  //       icon: 'rms_translate',
  //       route: 'AdminTags',
  //       params: {
  //         tag_type: DEFINES.TAG_TYPE.FOR_LANGUAGES,
  //       },
  //     },
  //     {
  //       title: i18n.t ('rms.drawer.admin.tag.media'),
  //       icon: 'rms_media',
  //       route: 'AdminTags',
  //       params: {
  //         tag_type: DEFINES.TAG_TYPE.FOR_FILM_MEDIA,
  //       },
  //     },
  //   ],
  // },
];

var company = company_id => {
  /**
   * If company is not selected yet then show companies list menus
   */
  if (!company_id) {
    return [
      {
        visible: true,
        title: i18n.t ('screener.admin.drawer.menu.company'),
        icon: 'rms_bank',
        route: 'Companies',
        params: {},
      },
    ];
  }

  return [
    {
      visible: company_id,
      title: i18n.t ('screener.admin.drawer.menu.pages'),
      icon: 'rms_agreement',
      route: 'page.list',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.filmmakers'),
      icon: 'company_filmmakers',
      route: 'film.makers.list',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: company_id,
      title: i18n.t ('screener.admin.drawer.menu.audience'),
      icon: 'rms_company_members',
      route: 'consumers.index',
      params: {
        company_id: company_id,
      },
    },
    {
      /* Visible to only company owner or admin &&  feature is enabled by SA */
      visible: isUserAllow (DEFINES.ROLE_ADMIN, company_id) && (store.getters['company/getSelectedCompany']).affiliation_enabled,
      title: i18n.t ('screener.admin.drawer.menu.affiliations'),
      icon: 'currency_usd',
      route: 'affiliations.index',
      params: {
        company_id: company_id,
      },
    },
    {
      /* Visible to only company owner, admin & right holder */
      visible: isUserAllow (DEFINES.ROLE_ADMIN, company_id) ||
        isUserRole (DEFINES.ROLE_RIGHT_HOLDER, company_id),
      title: i18n.t ('screener.admin.drawer.menu.revenue'),
      icon: 'screener_revenue',
      route: 'revenue.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.payout'),
      icon: 'screener_sales',
      route: 'payout.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('subscription.title'),
      icon: 'screener_sales',
      route: 'subscription.list',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('company.menu.translation.title'),
      icon: 'rms_translate',
      route: 'translation.tags',
      params: {
        company_id: company_id,
      },
    },
    // {
    //   /* Visible to only company owner, admin  */
    //   visible: isUserAllow (DEFINES.ROLE_ADMIN, company_id),
    //   title: 'Billing',
    //   icon: 'screener_sales',
    //   route: 'transaction.index',
    //   params: {
    //     company_id: company_id,
    //   },
    // },
  ];
};

const INVOICE_HEADERS = [
  {text: 'AMOUNT', align: 'left', sortable: false, value: 'amount'},
  {text: 'STATUS', align: 'left', sortable: false, value: 'status'},
  {
    text: 'INVOICE NUMBER',
    align: 'left',
    sortable: false,
    value: 'invoice_number',
  },
  {text: 'CUSTOMER', align: 'left', sortable: false, value: 'customer'},
  {text: 'DUE DATE', align: 'left', sortable: false, value: 'due_date'},
  {text: 'CREATED', align: 'left', sortable: false, value: 'created'},
  {text: 'PAID AT', align: 'left', sortable: false, value: 'paid_at'},
  {text: '', align: 'left', sortable: false, value: ''},
];

// var avails_manager = company_id => {
//   if (!company_id) {
//     return [];
//   }
//   return [
//     {
//       visible: isUserAllow (DEFINES.ROLE_MEMBER, company_id),
//       title: 'Avail Links',
//       icon: 'rms_media_link',
//       route: 'AvailLinksList',
//       params: {
//         company_id: company_id,
//       },
//     },
//   ];
// };

var SCREENER = company_id => {
  if (!company_id) {
    return [];
  }
  return [
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.screener'),
      icon: 'rms_film',
      route: 'screener.list',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('menu.title.vod'),
      icon: 'rms_film',
      route: 'vod.list',
      query: {
        isVodEvent: true
      },
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.venue.subheading'),
      icon: 'mew_theater',
      route: 'venue.list',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.passes'),
      icon: 'screener_group_ticket',
      route: 'group.ticket.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('coupon_code.label'),
      icon: 'coupons_icon',
      route: 'company.coupon.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.transaction'),
      icon: 'screener_sales',
      route: 'purchase.index',
      params: {
        company_id: company_id,
      },
    },

  ];
};

var COMMON = company_id => {
  /**
   * If company is not selected yet then show companies list menus
   */
   if (!company_id) {
    return [
      {
        visible: true,
        title: i18n.t ('screener.admin.drawer.menu.company'),
        icon: 'rms_bank',
        route: 'Companies',
        params: {},
      },
    ];
  }

  return [
    // 1. Company dashboard
    {
      visible: isUserAllow (DEFINES.ROLE_MEMBER, company_id),
      title: i18n.t ('screener.admin.drawer.menu.dashboard'),
      icon: 'rms_company_dashboard',
      route: 'CompanyDashboard',
      params: {
        company_id: company_id,
      },
    },

    //2. Media manager
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.media_manager'),
      icon: 'rms_movie',
      route: 'FilmsDashboard',
      params: {
        company_id: company_id,
      },
    },

    //3. Venue manager
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.venue.subheading'),
      icon: 'mew_theater',
      route: 'venue.list',
      params: {
        company_id: company_id,
      },
    },

    //4. Schedule events
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.screener'),
      icon: 'rms_film',
      route: 'screener.list',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('menu.title.vod'),
      icon: 'rms_film',
      route: 'vod.list',
      query: {
        isVodEvent: true
      },
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('menu.title.programs'),
      icon: 'netfest_programs',
      route: 'programs.list',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.passes'),
      icon: 'screener_group_ticket',
      route: 'group.ticket.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.company.facebook_pixel'),
      icon: 'analytics_icon',
      route: 'analytics.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('coupon_code.label'),
      icon: 'coupons_icon',
      route: 'company.coupon.index',
      params: {
        company_id: company_id,
      },
    },
    {
      visible: true,
      title: i18n.t ('screener.admin.drawer.menu.transaction'),
      icon: 'screener_sales',
      route: 'purchase.index',
      params: {
        company_id: company_id,
      },
    }
  ];
}

export {USER, company, ADMIN, INVOICE_HEADERS, SCREENER, COMMON};
